import { CircularProgress, Divider, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import Container from './container.component';

export function CircularLoaderContainer({
  sx,
  title,
  description,
}: {
  sx?: SxProps<Theme>;
  title?: string;
  description?: string;
}) {
  return (
    <Container sx={{ textAlign: 'center', py: 6, ...sx }}>
      {title ? (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      ) : null}
      {description ? (
        <Typography variant="body1" gutterBottom>
          {description}
        </Typography>
      ) : null}
      {title || description ? <br /> : null}
      <CircularProgress />
    </Container>
  );
}
